import React from 'react';

const SupportTicketIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">help</span>
            </>
      );
};

export default SupportTicketIcon;
